import React from "react";

const MissionVission = () => {
  return (
    <div className="about__tab_p">
      <h4>Mission Vission</h4>
      <p>
        Our mission is to create potential opportunities by making the best use
        of the advantages of the internet.
      </p>
      <p>
        Our vision is to become the main point of contact for individuals and
        institutions to share their thoughts and carry out their research. By
        doing this, we aim to:
      </p>
      <p>
        <ul>
          <li>
            To ensure that people can convey their wishes and opinions at the
            first stage of the institutions' work, and to increase satisfaction
            in the services, services and/or products that will be offered to
            them later on.
          </li>
          <li>
            To enable institutions to be more efficient and effective in their
            work by shaping their services, services and/or products in the
            light of the thoughts and comments they receive from their members.
          </li>
          <li>
            To play a role in the growth of institutions by increasing their
            competitiveness.
          </li>
        </ul>
      </p>
    </div>
  );
};

export default MissionVission;
